/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PaintbrushThinMinusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABYUlEQVR4nO2Uu0pDQRCG10K8FCLa2XoBOwu1tbE44JnLEfbMxCDpUoqPYGWpiK+gIiEPoCAWBt8iaKeFxNgZQYmcJAQxySbZpMwP2w3f/PPv7BozUkNEe2vAeg2kF4i6YIalIEjPAMkZkH4ja7V2SK6GAscoViB5aYKbDTQ3EBjALgHLTQuYtQokP8ypTS+wtXYKSI6QtdIO3nB/7gVH1HVkfeoIrsNfiTKzfcOZ9+eB9MMJT04Up73cA+lhNziw3htjxrwaIOudE076xSyrXvAwDKcTgDt7OTa+CoJgAkiLjmieExN97Tiy5JNLBZYyspwyy2ICaoVLOYzijZ7hzLICpKU2Li9rTeqTVJD0FiM9sNbO9RVH4rxzFHKSzWbHtzKZSeMr967Luze4OQHJp2MVS4PBMd7u8g3k/tYD62PXl01S6LFY3nZ2U8v/pi308LofnMX1O5F8sroDxTOScegXhO9h32KFEAMAAAAASUVORK5CYII=)
 */
export const PaintbrushThinMinusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="m11.33 14.83-2.16-2.16a1 1 0 0 1-.25-.99l.75-2.57A3 3 0 0 1 11 7.4l8.05-4.91a1.8 1.8 0 0 1 2.47 2.47L16.61 13a3 3 0 0 1-1.72 1.32l-2.57.75a1 1 0 0 1-.99-.25ZM8.74 13.57c-.2-.2-.44-.36-.7-.43a4 4 0 0 0-5 4.42C3.14 18.23 2.68 19 2 19a1 1 0 1 0 0 2h5a4 4 0 0 0 3.86-5.03c-.07-.27-.23-.51-.43-.7l-1.7-1.7ZM15 18a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8Z"
        className={colorClass}
      />
    </svg>
  );
};
